<script setup lang="ts">
import GuestLayout from "@/Layouts/GuestLayout.vue";
import AuthButton from "@/Components/auth/AuthButton.vue";
import AuthGoogleButton from "@/Components/auth/AuthGoogleButton.vue";
import AuthSwitch from "@/Components/auth/AuthSwitch.vue";
import AuthTextInput from "@/Components/auth/AuthTextInput.vue";
import { Head, useForm } from "@inertiajs/vue3";
import ButtonUnderline from "@/Components/figma_components/ButtonUnderline.vue";

defineProps<{
  canResetPassword?: boolean;
  status?: string;
  env?: string;
}>();

const form = useForm({
  email: "",
  password: "",
  remember: false,
});

const submit = () => {
  form.post(route("login"), {
    onFinish: () => form.reset("password"),
  });
};
</script>

<template>
  <GuestLayout>
    <Head title="Inicia sesión" />

    <!-- Encabezado -->
    <div class="flex w-full flex-col gap-2">
      <h1 class="text-[32px] font-bold leading-[34px] text-bnavy-80">
        Bienvenido a Envíoclick
      </h1>
      <div class="flex flex-wrap items-center gap-1">
        <span class="text-sm leading-[18px] text-bnavy-80">
          ¿Aún no tienes una cuenta?
        </span>
        <ButtonUnderline
          :href="route('register')"
          class="py-1 text-sm font-medium text-bnavy underline"
          :external="false"
        >
          Regístrate
        </ButtonUnderline>
      </div>
    </div>

    <p v-if="status" class="text-sm font-medium text-green-600">
      {{ status }}
    </p>

    <form class="flex w-full flex-col gap-6" @submit.prevent="submit">
      <div class="flex w-full flex-col gap-4">
        <AuthGoogleButton>Iniciar sesión con Google</AuthGoogleButton>

        <div class="flex w-full items-center gap-4 py-2">
          <span aria-hidden="true" class="h-[0.8px] flex-1 bg-bnavy-30"></span>
          <span class="text-sm leading-[18px] text-bnavy-80">o</span>
          <span aria-hidden="true" class="h-[0.8px] flex-1 bg-bnavy-30"></span>
        </div>

        <div class="flex w-full flex-col gap-3">
          <AuthTextInput
            id="email"
            v-model="form.email"
            label="Correo"
            type="email"
            autocomplete="username"
            required
            :error="form.errors.email"
          />
          <AuthTextInput
            id="password"
            v-model="form.password"
            label="Contraseña"
            type="password"
            autocomplete="current-password"
            required
            :error="form.errors.password"
          />
        </div>
      </div>

      <AuthButton type="submit" :disabled="form.processing">
        Iniciar sesión
      </AuthButton>

      <div class="flex w-full items-center justify-between gap-4">
        <AuthSwitch v-model="form.remember">Recordarme</AuthSwitch>
        <ButtonUnderline
          v-if="canResetPassword"
          :href="route('password.request')"
          class="py-1 text-sm font-medium text-bnavy underline"
          :external="false"
        >
          Recuperar contraseña
        </ButtonUnderline>
      </div>
    </form>
  </GuestLayout>
</template>
